import * as z from "zod";

const commentsoldIntegrationSchema = z.object({
  enabled: z.boolean(),
  team: z.string(),
  shop: z.string(),
  returnsEnabled: z.boolean(),
  omsSettings: z.object({
    enabled: z.boolean(),
    useCommentsoldProductInfoForShopifyFulfillments: z.boolean(),
  }),
  marketingEnabled: z.boolean(),
  fsrTitleText: z.string().optional(),
  fsrPositiveSubtext: z.string().optional(),
});

export type CommentsoldIntegration = z.infer<
  typeof commentsoldIntegrationSchema
>;

export const getCommentsoldIntegration = {
  name: "getCommentsoldIntegration" as const,
  input: z.object({}),
  output: z.object({ integration: commentsoldIntegrationSchema.nullable() }),
};
